import state from "./moduleBroadcastState";
import mutations from "./moduleBroadcastlMutations";
import actions from "./moduleBroadcastActions";
import getters from "./moduleBroadcastlGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}